import { render, staticRenderFns } from "./luckBoxes2.vue?vue&type=template&id=198aacd9&scoped=true&"
import script from "./luckBoxes2.vue?vue&type=script&lang=js&"
export * from "./luckBoxes2.vue?vue&type=script&lang=js&"
import style0 from "./luckBoxes2.vue?vue&type=style&index=0&id=198aacd9&prod&lang=css&"
import style1 from "./luckBoxes2.vue?vue&type=style&index=1&id=198aacd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198aacd9",
  null
  
)

export default component.exports